/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface BridgerPay
 */
export class BridgerPay {
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    cashierKey: string;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    password: string;
    /**
     *
     * @type {boolean}
     * @memberof BridgerPay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BridgerPay
     */
    autoApprove: boolean;
    /**
     *
     * @type {string}
     * @memberof BridgerPay
     */
    version: BridgerPayVersionEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum BridgerPayVersionEnum {
    V1 = 'v1',
    V2 = 'v2',
}
